import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom"
import { UserProvider } from './context/User/user.context';
import { TeacherProvider } from './context/Teacher/teacher.context';
import { OTPProvider } from "./context/otp/otp.context"
import "bootstrap/dist/css/bootstrap.min.css"
import { AdminProvider } from './context/Admin/Admin.context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AdminProvider>
        <OTPProvider>
          <TeacherProvider>
              <UserProvider>
                  <App />
              </UserProvider>
          </TeacherProvider>  
        </OTPProvider>
      </AdminProvider>
    </BrowserRouter> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
